import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

import styles from './ServiceStats.scss';

class ServiceStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startScreen: true,
      currentScreen: 0
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { currentScreen } = nextState;
    const { screens } = nextProps.content;
    const newScreen = screens[currentScreen];

    if (!newScreen.data) {
      return false;
    }

    return true;
  }

  setButtonConfig = () => {
    const { startScreen } = this.state;
    const { routes } = this.props.content;

    let config = {
      center: {
        onClick: this.cycle
      }
    };

    if (startScreen) {
      config = Object.assign(config, {
        left: {
          destination: routes.left
        },
        right: {
          destination: routes.right
        }
      });
    }

    return config;
  }

  cycle = () => {
    const { currentScreen } = this.state;
    const { screens } = this.props.content;
    let newScreen = currentScreen + 1;
    let isStartScreen = false;

    if (newScreen >= screens.length) {
      newScreen = 0;
      isStartScreen = true;
    }

    this.setState({
      startScreen: isStartScreen,
      currentScreen: newScreen
    });
  }

  render() {
    const {
      startScreen,
      currentScreen
    } = this.state;
    const { title, screens } = this.props.content;

    const buttonConfig = this.setButtonConfig();
    const screen = screens[currentScreen];

    const screenTitle = screen.title || title;

    return [
      <Display key="display">
        <Header>
          <HeaderText value={screenTitle} />
        </Header>
        <Content>
          <div
            className={`${styles.container}
            ${screen.wrapContent ? styles.wrap : ''}
            ${screen.flowType === 'gas' ? styles.gas : ''}`}
          >
            <Labels values={screen.data} />
          </div>
        </Content>
        <Footer align={!startScreen ? 'center' : ''}>
          {startScreen && <DisplayButton src="icon-xm-left-arrow" />}
          {screens.length > 1 && <DisplayButton src="icon-xm-cycle" />}
          {startScreen && <DisplayButton src="icon-xm-right-arrow" />}
        </Footer>
      </Display>,
      <HardwareButtonWrapper key="buttons" config={buttonConfig} />
    ];
  }
}

ServiceStats.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired
};

export default ServiceStats;



// WEBPACK FOOTER //
// ./src/screens/shared/Service/ServiceStats/ServiceStats.js